export enum GLRenderStage {
    Background,
    Foreground
}

export default GLRenderStage;
